import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Layout, Menu, Affix } from 'antd';

import traderion_logo from 'assets/images/traderion_logo.svg';
import vega_simulators_transparent from 'assets/images/vega_simulators_transparent.png';
import { HOST } from 'settings';

type props = {
  defaultKey: string;
  home?: string;
  level?: number;
  children?: React.ReactNode;
};

const EmptyHeader: React.FC<props> = ({
  defaultKey,
  home,
  level,
  children,
}) => {
  const { pathname } = useLocation();
  const pathStrings = pathname.split('/');
  const key = level ? pathStrings[level] : pathStrings.slice(-1)[0];

  let img = (
    <img
      src={vega_simulators_transparent}
      alt="vegasimulator logo"
      style={{ width: 130 }}
    />
  );
  if (HOST == 'TRADERION') {
    img = <img src={traderion_logo} alt="traderion logo" />;
  }

  return (
    <Affix>
      <Layout.Header className="header app-header">
        <Menu
          className="app-header__menu"
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={[defaultKey]}
          selectedKeys={[key]}
        >
          <Menu.Item
            className="app-header__brand"
            disabled={!home}
            style={{ cursor: home ? 'pointer' : 'auto' }}
          >
            <Link className="app-header__brand-link" to={home || '/'}>
              {img}
            </Link>
          </Menu.Item>
          {children}
        </Menu>
      </Layout.Header>
    </Affix>
  );
};

export default EmptyHeader;
